import * as React from 'react';
import history from '../history';
import { firebase } from '../../firebase';
import { Button } from '@material-ui/core';
import PhoneIcon from '@material-ui/icons/Phone';

// =====================================
// STORES
import { commonStore } from '../../store/CommonStore';
import { loginStore } from '../../store/LoginStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';

export default class Welcome extends React.Component<any, any> {

    componentDidMount() {
        firebase.auth().onAuthStateChanged((currentUser: firebase.User) => {
            if (loginStore.type === "login" || loginStore.type === "register") return;

            commonStore.isUserLoggedIn = (commonStore.getLocalStorageItem("isUserLoggedIn") === "true");
            if (currentUser && commonStore.isUserLoggedIn) {
                // ToDo proveriti da li je user ulogovan?????
                commonStore.setLocalStorageItem("userId", currentUser.uid);
                history.push('/customers');
            }
        });
    }

    goToPage = (url: string) => {
        history.push(`/${url}`);
    }

    render() {
        return (
            <div className="welcome-container">
                <Header
                    title="mKomercijalista" />

                <h2 className="welcome-title">Dobrodošli</h2>

                <div className="welcome-btn-container">
                    <h3>Ulogujte se sa vašim brojem telefona</h3>
                    <Button
                        variant="contained"
                        color="default"
                        className="btn-welcome-login"
                        startIcon={<PhoneIcon />}
                        onClick={() => { this.goToPage("login") }}
                    > Ulogujte se
                    </Button>
                </div>

                <div className="welcome-btn-container">
                    <h3>Registrujte se sa vašim brojem telefona</h3>
                    <Button
                        variant="contained"
                        color="default"
                        className="btn-welcome-login"
                        startIcon={<PhoneIcon />}
                        onClick={() => { this.goToPage("register") }}
                    > Registrujte se
                    </Button>
                </div>
            </div>
        );
    }
}